/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSupplyModel as DigiworkMaitreDPosDtoMenuUpdateSupplyModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/update-supply-model';

export interface UpdateSupply$Params {
      body?: DigiworkMaitreDPosDtoMenuUpdateSupplyModel
}

export function updateSupply(http: HttpClient, rootUrl: string, params?: UpdateSupply$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSupply.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSupply.PATH = '/api/gmn/Supply/updatesupply';
